import Vue from 'vue';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';
import LoginPlugin from '@tencent/vft-vue-plugins/src/login';
import ImgPlugin from '@tencent/vft-vue-plugins/src/img/v-img';
import ScrollLockerPlugin from '@tencent/vft-vue-plugins/src/scroll/v-lock-scroll';
import IconShare from '@tencent/vft-component/IconShare';
import Avatar from '@tencent/vft-ui/src/Avatar';
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation';
import reportPlugin from '@tencent/vft-report';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import Aegis from '@tencent/aegis-web-sdk';
import PortalVue from 'portal-vue';
import { lockScroll } from '@vip-activity/vue-lib/directives';
import { vipService } from '@vip-activity/business';
import config from '../config';
Vue.directive('lockScroll', lockScroll);
Vue.use(LoginPlugin);
Vue.use(dialogPlugin);
Vue.use(ImgPlugin);
Vue.use(ScrollLockerPlugin);
Vue.use(ScreenOrientation);
Vue.use(Avatar);
Vue.use(IconShare);
Vue.use(PortalVue);
Vue.use(reportPlugin, {
  config: {
    pv: {
      bossId: 5380,
      pwd: 895678138
    },
    event: {
      bossId: 5380,
      pwd: 895678138
    }
  },
  observerOptions: {
    root: document.getElementById('#app')
  },
  extraParams: function extraParams() {
    var loginType = login.loginType();
    return {
      f_logintype: loginType,

      /** 登录用户的vuid，用于精细化 */
      f_vuid: config.vuid,

      /** 获取登录账号 id */
      f_uid: login.getUid(),
      f_appid: loginType === 'wx' ? cookie.get('appid') : login.isNewQQLogin() ? cookie.get('vqq_appid') : '',
      f_vip: vipService.isInited ? vipService.isVip ? 1 : 0 : -1,
      f_level: vipService.level,
      f_version: 1
    };
  },

  /** 是否延迟上报，若延迟上报，需通过主动调用 this.$report.ready() 启动上报 */
  delay: true,

  /** 是否输出调试信息，true为不输出 */
  silent: true
});
var aegis = new Aegis({
  id: '2647',
  // 项目ID
  uin: config.vuid,
  reportApiSpeed: true,
  // 接口测速
  reportAssetSpeed: true // 静态资源测速

});
window.aegis = aegis;